import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Logo from "../../../Images/profile_logo.png";
import useStyles from "./style";
import { setUser } from "../../../redux-tools/actions/userActions";
import { connect } from "react-redux";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import http from "../../Common/RestAPIHandler";

import Alert from "@material-ui/lab/Alert";
import commonConstants from "../../Common/CommonConstants";
import { Link as RouterLink } from "react-router-dom";
import Link from "@material-ui/core/Link";

const Login = (props) => {
  const classes = useStyles();
  const [user, setUserData] = useState({ email: "", password: "" });
  const [invalidUser, setInvalidUser] = useState(false);

  useEffect(() => {
    // Cache clearing removed - handled at API level for authentication endpoints only
  }, []);
  
  const [invalidPassword, setInvalidPassword] = useState(false);
  const [accessDenied, setAccessDenied] = useState(false);
  const [locked, setLocked] = useState(false);
  const [lockoutTime] = useState("");
  const [invalid, setInvalid] = useState(false);
  const errorText = commonConstants.error;
  const [isSubmitted, setIsSubmitted] = useState(false);

  const resetAll = () => {
    setInvalid(false);
    setLocked(false);
    setInvalidUser(false);
    setInvalidPassword(false);
    setAccessDenied(false);
  };

  const onInputChange = (e) => {
    setUserData({ ...user, [e.target.name]: e.target.value });
    resetAll();
  };

  const onSubmit = (e) => {
    e.preventDefault();
    resetAll();
    setIsSubmitted(true);
    
    // Cache clearing removed - handled at API level now
    
    http.Get(
      `reseller/login/?email=${user.email}`,
      (response) => {
        // Initialize new session for this tenant/user combination
        // Session management removed - only keeping logout cache busting
        
        if(response.next_step === "onelogin"){
          localStorage.setItem("onelogin_user_email",user.email);
          localStorage.setItem("onelogin_url",response.onelogin_url);
          localStorage.setItem("onelogin_client_id",response.onelogin_client_id);
          props.history.replace(process.env.PUBLIC_URL + "/reseller/oneloginsso");
        }
        if(response.next_step === "azuresso"){
          localStorage.setItem("azure_user_email",user.email);
          localStorage.setItem("azure_tenant_id",response.azure_tenant_id);
          localStorage.setItem("azure_client_id",response.azure_client_id);
          localStorage.setItem("azure_client_secret",response.azure_client_secret);
          props.history.replace(process.env.PUBLIC_URL + "/reseller/azuresso");
        }
        else{
          localStorage.setItem("user_email",user.email);
          props.history.replace(process.env.PUBLIC_URL + "/reseller/passwordlogin");
        }
      },
      (status, error) => {
        setInvalidUser(true);
      }
    );
  };

  return (
    <div>
      <div className={classes.main}>
        <div className={classes.root}>
          <ValidatorForm onSubmit={onSubmit}>
            <Grid
              container
              spacing={0}
              alignItems="center"
              justify="center"
              className={classes.container}
            >
              <Grid item xs={12}>
                <Grid container spacing={3}>
                  <Grid item xs={12} className={classes.centerElement}>
                    <Typography variant="h6" color="inherit" noWrap>
                      <img
                        src={Logo}
                        alt="Not Available"
                        className={classes.logo}
                      />
                    </Typography>
                  </Grid>
                  <Grid item xs={12} className={classes.centerElement}>
                    <Typography
                      variant="h5"
                      component="h4"
                      color="textSecondary"
                    >
                      Reseller Login
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <TextValidator
                      id="outlined-email-input"
                      label="E-mail"
                      type="text"
                      name="email"
                      variant="outlined"
                      fullWidth
                      value={user.email || ""}
                      onChange={onInputChange}
                      validators={["required", "trim", "isEmail"]}
                      errorMessages={[
                        errorText.requiredError,
                        errorText.blankError,
                        errorText.invalidEmailError,
                      ]}
                    />
                  </Grid>

                  {(invalidPassword || invalidUser || accessDenied) && (
                    <Grid item xs={12}>
                      <Alert severity="error" variant="filled">
                        Username or password incorrect!
                      </Alert>
                    </Grid>
                  )}

                  {locked && (
                    <Grid item xs={12}>
                      <Alert severity="error" variant="filled">
                        Your account is temporarily locked for {lockoutTime} minutes due to multiple failed login attempts
                        .
                      </Alert>
                    </Grid>
                  )}


                  {invalid && (
                    <Grid item xs={12}>
                      <Alert severity="error" variant="filled">
                        Unknown error. Please try again later.
                      </Alert>
                    </Grid>
                  )}

                  <Grid item xs={12}>
                    <Grid container spacing={3}>
                      <Grid item xs={6}>
                        <Link
                          component={RouterLink}
                          to={process.env.PUBLIC_URL + "/forgetPassword?userType=Reseller User"}
                          color="textPrimary"
                        >
                          Forgot password?
                        </Link>
                      </Grid>
                      <Grid item xs={6} className={classes.rightElement}>
                        <Button
                          type="submit"
                          className={classes.outlinedButton}
                          variant="outlined"
                          disabled={isSubmitted}
                        >
                          Next
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </ValidatorForm>
        </div>
      </div>
    </div>
  );
};
export default connect(null, { setUser })(Login);